import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { message, Spin } from "antd";

import * as actions from "../../actions";
import Form from "./Form";
import { PageTitle, ReportBtn } from "lib/widget";

import * as moment from "moment";

const initialState = {
  branchId: null,
  startDate: null,
  endDate: null,
  pickStartDate: null,
  pickEndDate: null,
};

class CustomerRetentionReport extends Component {
  constructor(props) {
    super(props);
    this.state = initialState;
    this.onKeyValueChange = this.onKeyValueChange.bind(this);
  }

  onKeyValueChange(name, value) {
    this.setState((state, props) => {
      return { ...state, [name]: value };
    });
  }

  onDateChange = (value) => {
    this.setState({ ...this.state, ...value });
  };

  clearFilter = () => {
    this.setState(initialState);
  };

  downloadCustomerRetention = () => {
    const {
      startDate,
      endDate,
      branchId,
      pickStartDate,
      pickEndDate,
    } = this.state;

    if (!startDate || !endDate) return message.error("Please select date");
    if (branchId === null) return message.error("Please select branch");

    let start = moment(pickStartDate + " 00:00:00")
      .utc()
      .format("YYYY-MM-DD HH:mm:ss");
    let end = moment(pickEndDate + " 23:59:59")
      .utc()
      .format("YYYY-MM-DD HH:mm:ss");

    this.props.downloadCustomerRetention(
      branchId,
      start,
      end,
      pickStartDate,
      pickEndDate
    );
  };

  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.errorMessage !== prevState.errorMessage) {
      return { errorMessage: nextProps.errorMessage };
    }
    return null;
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.errorMessage !== this.props.errorMessage) {
      message.error(this.props.errorMessage);
    }
  }

  componentDidMount() {
    this.props.loadReportBranch();
  }

  render() {
    return (
      <Fragment>
        <PageTitle name="report_customer_retention" component={null} />
        <Spin size="large" spinning={this.props.loading}>
          <Form
            {...this.state}
            branches={this.props.branches}
            onDateChange={this.onDateChange}
            onKeyValueChange={this.onKeyValueChange}
          />
          <ReportBtn
            onDowload={this.downloadCustomerRetention}
            onClear={this.clearFilter}
          />
        </Spin>
      </Fragment>
    );
  }
}

const mapStateToProps = ({ reports }) => ({
  branches: reports.branches,
  loading: reports.retention_loading,
  errorMessage: reports.errorMessage,
});

const mapDispatchToProps = {
  downloadCustomerRetention: actions.downloadCustomerRetention.request,
  loadReportBranch: actions.loadReportBranch.request,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CustomerRetentionReport);
